import { Stack } from '@mui/material';
import { LinkReturnToLobby } from '../LinkReturnToLobby';
import { Header } from './Header';
import { Results } from './Results';
import { useCallback, useContext, useEffect } from 'react';
import { Loading } from './Loading';
import { getSuppliers } from 'API/Suppliers/suppliers';
import { useLoader } from 'Hooks/useLoader';
import { SUPPLIER_RESULT_FILTER, SUPPLIERS_STEPS } from 'Enum/suppliers';
import { useScrollTopView } from 'Hooks/useScrollTopView';
import { Helmet } from 'react-helmet-async';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useSupplierContext } from 'Hooks/useSupplierContext';

export const ResultPages = () => {
  useScrollTopView({ top: 0, smoothScroll: true });
  const { suppliersId, setStepIndex } = useContext(SuppliersContext);
  const { filters, dispatchSuppliers } = useSupplierContext();

  const { isLoading, setIsLoading } = useLoader();

  const initSuppliers = useCallback(async () => {
    setIsLoading(true);
    const suppliersResult = filters.specialty
      ? await getSuppliers(suppliersId, filters.specialty)
      : setStepIndex(SUPPLIERS_STEPS.FORM);

    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.Init,
      payload: suppliersResult ?? [],
    });
    setIsLoading(false);
  }, [setIsLoading, setStepIndex, filters.specialty]);

  useEffect(() => {
    initSuppliers();
  }, [initSuppliers]);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Helmet
            title={`${Dictionary[DICTIONARY.Suppliers].title} ${
              Dictionary[DICTIONARY.Suppliers].resultPage.title
            }`}
          />
          <LinkReturnToLobby />
          <Stack
            sx={{
              m: '0 auto',
              maxWidth: '800px',
            }}
          >
            <Header />
            <Results />
          </Stack>
        </>
      )}
    </>
  );
};
